import ReservationTimeLine from "./ReservationTimeLine";

class ReservationTimeLines {
  constructor(private readonly _list: ReservationTimeLine[] = []) {
  }

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }

  public toList(): ReservationTimeLine[] {
    return this._list;
  }
}

export default ReservationTimeLines;
